/** @format */

import {Box, Button} from '@mui/material';
import {styled} from '@mui/material/styles';

import PrimaryMediumButton from 'components/buttons/PrimaryMediumButton';

export const StatusBadge = styled(Box, {
  shouldForwardProp: prop => prop !== 'isActive',
})<{isActive: boolean}>(({theme, isActive}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(0.5, 2),
  borderRadius: '9px',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '16px',
  backgroundColor: isActive ? theme.palette.semantic_dark?.secondary.container : '#664214',
  color: isActive
    ? theme.palette.semantic_dark?.secondary.onContainer
    : theme.palette.semantic_dark?.alert.onContainer,
}));

export const MonitoringGridContainer = styled(Box)(({theme}) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: theme.spacing(8),
  marginTop: theme.spacing(3),

  '& > *': {
    minWidth: 0,
  },

  '& .MuiChip-root': {
    maxWidth: '100%',
  },
}));

export const ButtonsContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  marginTop: theme.spacing(4),
}));

export const MonitoringSubmitButton = styled(PrimaryMediumButton)<{disabled?: boolean}>(
  ({disabled, theme}) => ({
    flex: 1,
    height: '44px',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: disabled ? 400 : 500,
    width: '100%',
    padding: theme.spacing(3.5),
    backgroundColor: disabled
      ? theme.palette.semantic_dark?.disabled.disabledLow
      : theme.palette.semantic_dark?.primary.main,
    color: disabled
      ? theme.palette.semantic_dark?.disabled.disabled
      : theme.palette.semantic_dark?.primary.on,
    border: 'none',
    opacity: 1,

    '&:hover': {
      backgroundColor: disabled
        ? theme.palette.semantic_dark?.disabled.disabledLow
        : theme.palette.semantic_dark?.primary.hover,
      opacity: 1,
    },

    '&:disabled': {
      backgroundColor: theme.palette.semantic_dark?.disabled.disabledLow,
      color: theme.palette.semantic_dark?.disabled.disabled,
    },
  }),
);

export const StopButton = styled(Button)(({theme}) => ({
  flex: 1,
  height: '44px',
  borderRadius: '8px',
  fontSize: '16px',
  fontWeight: 500,
  padding: theme.spacing(3.5),
  backgroundColor: theme.palette.semantic_dark?.surface.surface2,
  color: theme.palette.semantic_dark?.surface.onSurface,
  border: 'none',
  textTransform: 'none',

  '&:hover': {
    backgroundColor: theme.palette.semantic_dark?.surface.surface3,
  },
}));

export const MonitoringStubContainer = styled(Box)(({theme}) => ({
  flex: 1,
  backgroundColor: theme.palette.semantic_dark?.surface.surface1,
  borderRadius: '0 8px 8px 0',
  padding: theme.spacing(4),
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
}));
